import { track } from "@/features/analytics";
import { SlidesLibraryDialog } from "@modules/slides-library/shared/components/slides-library-dialog";
import { useAppDispatch, useAppSelector } from "@store";
import { setContentSlide } from "@store/ai-slides";
import { openDialog } from "@store/dialogs";
import { getThumbnailId } from "@store/story/selectors";
import { useSlidesLimit } from "./use-slides-limit";

export const useTriggerAddSlide = () => {
  const { isLimitReached, lockAction } = useSlidesLimit();
  const activeThumbnailId = useAppSelector(getThumbnailId);
  const dispatch = useAppDispatch();

  const openAddSlide = (id?: string) => {
    if (isLimitReached) return lockAction();
    track("click add new slide");
    const slideId = id || activeThumbnailId;
    dispatch(setContentSlide({ id: slideId as string, placement: "bottom" }));
    dispatch(
      openDialog({
        id: SlidesLibraryDialog.id,
        content: SlidesLibraryDialog,
        props: {
          view: "editor",
          initialTab: "saved",
          initialSavedSection: "user-slides",
        },
      }),
    );
  };

  return { openAddSlide };
};
